import { useNavigate } from "react-router-dom";
import { Card } from "../ui/card";
import { rupee } from "../shared";
import { ChevronRight } from "lucide-react";

export function Win({ title, icon: Icon, to, testid, children, className = "" }) {
  const navigate = useNavigate();
  const clickable = !!to;
  return (
    <Card data-testid={testid} onClick={clickable ? () => navigate(to) : undefined}
      role={clickable ? "button" : undefined} tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter") navigate(to); } : undefined}
      className={`group relative flex flex-col p-5 bg-card border-border min-h-[240px] transition-colors ${clickable ? "cursor-pointer hover:border-primary/70 hover:bg-secondary/30" : ""} ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{title}</p>
        <div className="flex items-center gap-2">
          {Icon && <div className="h-8 w-8 rounded-sm bg-primary/15 flex items-center justify-center text-primary"><Icon size={16} /></div>}
          {clickable && <ChevronRight size={16} className="text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />}
        </div>
      </div>
      <div className="flex-1">{children}</div>
    </Card>
  );
}

export const Big = ({ children, testid, className = "" }) => (
  <p className={`font-display text-3xl font-medium leading-none ${className}`} data-testid={testid}>{children}</p>
);

export const Row = ({ label, value, testid, muted, strong, accent }) => (
  <div className="flex items-baseline justify-between gap-3 text-sm py-1 border-b border-border/60 last:border-0">
    <span className={muted ? "text-muted-foreground" : ""}>{label}</span>
    <span data-testid={testid} className={`${strong ? "font-semibold" : ""} ${accent ? "text-primary" : ""}`}>{value}</span>
  </div>
);

export const Empty = ({ text }) => <p className="text-sm text-muted-foreground mt-4">{text}</p>;

export const money = (n) => rupee(n);
